import dayjs from "dayjs"
import "dayjs/locale/es"
import utc from "dayjs/plugin/utc"
import weekday from "dayjs/plugin/weekday"
import timezone from "dayjs/plugin/timezone"
import localeData from "dayjs/plugin/localeData"
import customParseFormat from "dayjs/plugin/customParseFormat"

dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(customParseFormat)

dayjs.extend(utc)
dayjs.extend(timezone)

dayjs.locale("es")

export { dayjs }